import React from 'react';

import { CoreIcon } from '@aspid/ui';
import { Box, Typography } from '@mui/material';

import { IconCollection } from '@components/icons/iconCollection';

import { spreadSxProperty } from '../../helpers';
import { styles } from '../DropZoneAreaBase.styles';

import type { DropZoneContentProperties } from './DropZoneContent.types';

export const DropZoneContent: React.FC<DropZoneContentProperties> = ({
  dataTest = 'dropzone_content',
  getRootProps,
  getInputProps,
  isDragActive,
  isDragAccept,
  dropzoneText,
  icon,
  inputProps,
  dropZoneStyles = {},
  dropzoneParagraphStyles = {},
  maxFileSizeFormatted,
  acceptedFormatsText,
}) => (
  <Box data-testid={dataTest}>
    <Box
      component='div'
      {...getRootProps()}
      sx={[
        theme => ({
          ...styles(theme).root,
          ...(isDragAccept && styles(theme).active),
          ...(isDragActive && !isDragAccept && styles(theme).invalid),
        }),
        ...spreadSxProperty(dropZoneStyles),
      ]}
    >
      <input {...getInputProps(inputProps)} data-testid='file_input' />
      <Box sx={theme => styles(theme).textContainer}>
        <Typography
          variant='h5'
          component='p'
          sx={[
            theme => ({ ...styles(theme).text }),
            ...spreadSxProperty(dropzoneParagraphStyles),
          ]}
        >
          {dropzoneText}
        </Typography>
        <CoreIcon
          icon={icon || IconCollection.uploadCloud}
          sx={{ fontSize: '2rem', mb: 3 }}
        />
      </Box>
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {acceptedFormatsText ? (
        <Typography
          sx={{
            fontSize: '12px',
            color: 'text.muted'
          }}>
          {acceptedFormatsText}
        </Typography>
      ) : (
        <Typography
          sx={{
            fontSize: '12px',
            color: 'text.muted'
          }}>
          {`Размер файла до ${maxFileSizeFormatted}`}
        </Typography>
      )}
    </Box>
  </Box>
);
